'use client';
import React,{ useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

export default function FormSection({ data, setData, sections, toggleSection, handleChange, handlePrint, handleDynamicChange, handleImageChange, addDynamicField, removeDynamicField, handleDownload }) {
  
  useEffect(() => {
    // Load data from local storage when the component mounts
    const savedData = localStorage.getItem('formData');
    if (savedData) {
      setData(JSON.parse(savedData));
    } else {
      // Initialize with dummy content if no data is found in local storage
      setData({
        name: 'Warren Hastings',
        jobTitle: 'Electrical Engineer',
        phone: '+123-456-7890',
        email: 'yourname@domain.com',
        address: 'Washington DC, 4567 USA',
        summary: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
        education: [
          { degree: 'Bachelor of Science in Electrical Engineering', institution: 'Harvard University', year: '2010 - 2014' },
          { degree: 'Master of Science in Electrical Engineering', institution: 'MIT', year: '2014 - 2016' }
        ],
        languages: ['English', 'Spanish'],
        experience: [
          { position: 'Senior Electrical Engineer', company: 'Tesla, Inc.', location: 'Palo Alto, CA', duration: '2016 - Present', details: 'Responsible for leading a team of engineers in the design and implementation of electrical systems.' },
          { position: 'Electrical Engineer', company: 'General Electric', location: 'New York, NY', duration: '2014 - 2016', details: 'Worked on various projects involving electrical systems design and optimization.' }
        ],
        awards: [
          { title: 'Best Electrical Engineer', year: '2018', details: 'Awarded for outstanding performance in electrical engineering.' }
        ],
        references: [
          { name: 'John Doe', position: 'Manager', phone: '+123-456-7890', email: 'johndoe@example.com' }
        ],
        socialMedia: [
          { platform: 'LinkedIn', handle: '@username' },
          { platform: 'Twitter', handle: '@username' },
          { platform: 'Facebook', handle: '/username' }
        ],
        expertise: [
          { skill: 'Electrical Circuit Design', number: '5' },
          { skill: 'Project Management', number: '3' },
        ],
      });
    }
  }, [setData]);

  return (
    <div className="md:w-[700px] w-full bg-white shadow-lg rounded-lg p-6">
      <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">Edit CV / تحرير السيرة الذاتية</h2>
      <form className="space-y-6">
        
        {/* Profile Picture Section */}
        <div>
          <label className="block text-lg font-medium text-gray-700">Profile Picture / صورة الملف الشخصي</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
          />
        </div>

        {/* Personal Details Section */}
        <div>
          <button
            type="button"
            onClick={() => toggleSection('personalDetails')}
            className="w-full text-left text-lg font-medium text-gray-700 py-2 border-b flex justify-between items-center focus:outline-none"
          >
            Personal Details / التفاصيل الشخصية
            <FontAwesomeIcon icon={sections.personalDetails ? faChevronUp : faChevronDown} />
          </button>
          {sections.personalDetails && (
            <div className="space-y-4">
              <div>
                <label className="block text-lg font-medium text-gray-700">Name / الاسم</label>
                <input
                  type="text"
                  name="name"
                  value={data.name}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-lg font-medium text-gray-700">Job Title / المسمى الوظيفي</label>
                <input
                  type="text"
                  name="jobTitle"
                  value={data.jobTitle}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-lg font-medium text-gray-700">Phone / الهاتف</label>
                <input
                  type="text"
                  name="phone"
                  value={data.phone}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-lg font-medium text-gray-700">Email / البريد الإلكتروني</label>
                <input
                  type="email"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-lg font-medium text-gray-700">Address / العنوان</label>
                <input
                  type="text"
                  name="address"
                  value={data.address}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          )}
        </div>

        {/* Summary Section */}
        <div>
          <button
            type="button"
            onClick={() => toggleSection('summary')}
            className="w-full text-left text-lg font-medium text-gray-700 py-2 border-b flex justify-between items-center focus:outline-none"
          >
            Summary / الملخص
            <FontAwesomeIcon icon={sections.summary ? faChevronUp : faChevronDown} />
          </button>
          {sections.summary && (
            <div>
              {/* <label className="block text-lg font-medium text-gray-700">Summary / الملخص</label> */}
              <textarea
                name="summary"
                value={data.summary}
                onChange={handleChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          )}
        </div>

        {/* Social Media Section */}
        <div>
          <button
            type="button"
            onClick={() => toggleSection('socialMedia')}
            className="w-full text-left text-lg font-medium text-gray-700 py-2 border-b flex justify-between items-center focus:outline-none"
          >
            Social Media / وسائل التواصل الاجتماعي
            <FontAwesomeIcon icon={sections.socialMedia ? faChevronUp : faChevronDown} />
          </button>
          {sections.socialMedia && (
            <div className="space-y-4">
              {Array.isArray(data.socialMedia) && data.socialMedia.length > 0 ? (
                data.socialMedia.map((media, index) => (
                  <div key={index} className="mb-4">
                    <select
                      value={media.platform}
                      onChange={(e) => handleDynamicChange(e, index, 'socialMedia', 'platform')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    >
                      <option value="">Select Platform / اختر المنصة</option>
                      <option value="LinkedIn">LinkedIn</option>
                      <option value="Twitter">Twitter</option>
                      <option value="Instagram">Instagram</option>
                      <option value="Facebook">Facebook</option>
                    </select>

                    <input
                      type="text"
                      placeholder="Handle / الحساب"
                      value={media.handle}
                      onChange={(e) => handleDynamicChange(e, index, 'socialMedia', 'handle')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <button
                      type="button"
                      onClick={() => removeDynamicField(index, 'socialMedia')}
                      className="text-red-500"
                    >
                      Remove / إزالة
                    </button>
                  </div>
                ))
              ) : (
                <p>No social media added yet. / لم تتم إضافة أي وسائل تواصل اجتماعي بعد.</p>
              )}
              <button
                type="button"
                onClick={() => addDynamicField('socialMedia')}
                className="mt-2 text-blue-500"
              >
                Add Social Media / إضافة وسيلة تواصل اجتماعي
              </button>
            </div>
          )}
        </div>

        {/* Educational Details Section */}
        <div>
          <button
            type="button"
            onClick={() => toggleSection('educationalDetails')}
            className="w-full text-left text-lg font-medium text-gray-700 py-2 border-b flex justify-between items-center focus:outline-none"
          >
            Educational Details / التفاصيل التعليمية
            <FontAwesomeIcon icon={sections.educationalDetails ? faChevronUp : faChevronDown} />
          </button>
          {sections.educationalDetails && (
            <div className="space-y-4">
              {Array.isArray(data.education) && data.education.length > 0 ? (
                data.education.map((edu, index) => (
                  <div key={index} className="mb-4">
                    <input
                      type="text"
                      placeholder="Degree / الدرجة العلمية"
                      value={edu.degree}
                      onChange={(e) => handleDynamicChange(e, index, 'education', 'degree')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <input
                      type="text"
                      placeholder="Institution / المؤسسة"
                      value={edu.institution}
                      onChange={(e) => handleDynamicChange(e, index, 'education', 'institution')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <input
                      type="text"
                      placeholder="Year / السنة"
                      value={edu.year}
                      onChange={(e) => handleDynamicChange(e, index, 'education', 'year')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <button
                      type="button"
                      onClick={() => removeDynamicField(index, 'education')}
                      className="text-red-500"
                    >
                      Remove / إزالة
                    </button>
                  </div>
                ))
              ) : (
                <p>No education details added yet. / لم تتم إضافة أي تفاصيل تعليمية بعد.</p>
              )}
              <button
                type="button"
                onClick={() => addDynamicField('education')}
                className="mt-2 text-blue-500"
              >
                Add Education / إضافة تعليم
              </button>
            </div>
          )}
        </div>

        {/* Expertise Details Section */}
        <div>
          <button
            type="button"
            onClick={() => toggleSection('expertiseDetails')}
            className="w-full text-left text-lg font-medium text-gray-700 py-2 border-b flex justify-between items-center focus:outline-none"
          >
            Expertise Details / تفاصيل الخبرة
            <FontAwesomeIcon icon={sections.expertiseDetails ? faChevronUp : faChevronDown} />
          </button>
          {sections.expertiseDetails && (
            <div className="space-y-4">
              {Array.isArray(data.expertise) && data.expertise.length > 0 ? (
                data.expertise.map((item, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    {/* Expertise Text */}
                    <input
                      type="text"
                      placeholder="Expertise Name / اسم الخبرة"
                      value={item.skill}
                      onChange={(e) => handleDynamicChange(e, index, 'expertise', 'skill')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    {/* Expertise Number */}
                    <input
                      type="number"
                      placeholder="Experience (Years) / الخبرة (سنوات)"
                      value={item.number}
                      onChange={(e) => handleDynamicChange(e, index, 'expertise', 'number')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <button
                      type="button"
                      onClick={() => removeDynamicField(index, 'expertise')}
                      className="text-red-500"
                    >
                      Remove / إزالة
                    </button>
                  </div>
                ))
              ) : (
                <p>No expertise added yet. / لم تتم إضافة أي خبرة بعد.</p>
              )}
              <button
                type="button"
                onClick={() => addDynamicField('expertise')}
                className="mt-2 text-blue-500"
              >
                Add Expertise / إضافة خبرة
              </button>
            </div>
          )}
        </div>

        {/* Language Details Section */}
        <div>
          <button
            type="button"
            onClick={() => toggleSection('languageDetails')}
            className="w-full text-left text-lg font-medium text-gray-700 py-2 border-b flex justify-between items-center focus:outline-none"
          >
            Language Details / تفاصيل اللغة
            <FontAwesomeIcon icon={sections.languageDetails ? faChevronUp : faChevronDown} />
          </button>
          {sections.languageDetails && (
            <div className="space-y-4">
              {Array.isArray(data.languages) && data.languages.length > 0 ? (
                data.languages.map((language, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <input
                      type="text"
                      placeholder="Language / اللغة"
                      value={language}
                      onChange={(e) => handleDynamicChange(e, index, 'languages')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <button
                      type="button"
                      onClick={() => removeDynamicField(index, 'languages')}
                      className="text-red-500"
                    >
                      Remove / إزالة
                    </button>
                  </div>
                ))
              ) : (
                <p>No languages added yet. / لم تتم إضافة أي لغات بعد.</p>
              )}
              <button
                type="button"
                onClick={() => addDynamicField('languages')}
                className="mt-2 text-blue-500"
              >
                Add Language / إضافة لغة
              </button>
            </div>
          )}
        </div>

        {/* Experience Details Section */}
        <div>
          <button
            type="button"
            onClick={() => toggleSection('experienceDetails')}
            className="w-full text-left text-lg font-medium text-gray-700 py-2 border-b flex justify-between items-center focus:outline-none"
          >
            Experience Details / تفاصيل الخبرة العملية
            <FontAwesomeIcon icon={sections.experienceDetails ? faChevronUp : faChevronDown} />
          </button>
          {sections.experienceDetails && (
            <div className="space-y-4">
              {Array.isArray(data.experience) && data.experience.length > 0 ? (
                data.experience.map((exp, index) => (
                  <div key={index} className="mb-4">
                    <input
                      type="text"
                      placeholder="Position / المنصب"
                      value={exp.position}
                      onChange={(e) => handleDynamicChange(e, index, 'experience', 'position')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <input
                      type="text"
                      placeholder="Company / الشركة"
                      value={exp.company}
                      onChange={(e) => handleDynamicChange(e, index, 'experience', 'company')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <input
                      type="text"
                      placeholder="Location / الموقع"
                      value={exp.location}
                      onChange={(e) => handleDynamicChange(e, index, 'experience', 'location')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <input
                      type="text"
                      placeholder="Duration / المدة"
                      value={exp.duration}
                      onChange={(e) => handleDynamicChange(e, index, 'experience', 'duration')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <textarea
                      placeholder="Details / التفاصيل"
                      value={exp.details}
                      onChange={(e) => handleDynamicChange(e, index, 'experience', 'details')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <button
                      type="button"
                      onClick={() => removeDynamicField(index, 'experience')}
                      className="text-red-500"
                    >
                      Remove / إزالة
                    </button>
                  </div>
                ))
              ) : (
                <p>No experience details added yet. / لم تتم إضافة أي تفاصيل خبرة بعد.</p>
              )}
              <button
                type="button"
                onClick={() => addDynamicField('experience')}
                className="mt-2 text-blue-500"
              >
                Add Experience / إضافة خبرة
              </button>
            </div>
          )}
        </div>

        {/* Awards Section */}
        <div>
          <button
            type="button"
            onClick={() => toggleSection('awards')}
            className="w-full text-left text-lg font-medium text-gray-700 py-2 border-b flex justify-between items-center focus:outline-none"
          >
            Awards / الجوائز
            <FontAwesomeIcon icon={sections.awards ? faChevronUp : faChevronDown} />
          </button>
          {sections.awards && (
            <div className="space-y-4">
              {Array.isArray(data.awards) && data.awards.length > 0 ? (
                data.awards.map((award, index) => (
                  <div key={index} className="mb-4">
                    <input
                      type="text"
                      placeholder="Award Title / عنوان الجائزة"
                      value={award.title}
                      onChange={(e) => handleDynamicChange(e, index, 'awards', 'title')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <input
                      type="text"
                      placeholder="Year / السنة"
                      value={award.year}
                      onChange={(e) => handleDynamicChange(e, index, 'awards', 'year')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <textarea
                      placeholder="Details / التفاصيل"
                      value={award.details}
                      onChange={(e) => handleDynamicChange(e, index, 'awards', 'details')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <button
                      type="button"
                      onClick={() => removeDynamicField(index, 'awards')}
                      className="text-red-500"
                    >
                      Remove / إزالة
                    </button>
                  </div>
                ))
              ) : (
                <p>No awards added yet. / لم تتم إضافة أي جوائز بعد.</p>
              )}
              <button
                type="button"
                onClick={() => addDynamicField('awards')}
                className="mt-2 text-blue-500"
              >
                Add Award / إضافة جائزة
              </button>
            </div>
          )}
        </div>

        {/* Reference Details Section */}
        <div>
          <button
            type="button"
            onClick={() => toggleSection('referenceDetails')}
            className="w-full text-left text-lg font-medium text-gray-700 py-2 border-b flex justify-between items-center focus:outline-none"
          >
            Reference Details / تفاصيل المرجع
            <FontAwesomeIcon icon={sections.referenceDetails ? faChevronUp : faChevronDown} />
          </button>
          {sections.referenceDetails && (
            <div className="space-y-4">
              {Array.isArray(data.references) && data.references.length > 0 ? (
                data.references.map((ref, index) => (
                  <div key={index} className="mb-4">
                    <input
                      type="text"
                      placeholder="Name / الاسم"
                      value={ref.name}
                      onChange={(e) => handleDynamicChange(e, index, 'references', 'name')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <input
                      type="text"
                      placeholder="Position / المنصب"
                      value={ref.position}
                      onChange={(e) => handleDynamicChange(e, index, 'references', 'position')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <input
                      type="text"
                      placeholder="Phone / الهاتف"
                      value={ref.phone}
                      onChange={(e) => handleDynamicChange(e, index, 'references', 'phone')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <input
                      type="email"
                      placeholder="Email / البريد الإلكتروني"
                      value={ref.email}
                      onChange={(e) => handleDynamicChange(e, index, 'references', 'email')}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2"
                    />
                    <button
                      type="button"
                      onClick={() => removeDynamicField(index, 'references')}
                      className="text-red-500"
                    >
                      Remove / إزالة
                    </button>
                  </div>
                ))
              ) : (
                <p>No references added yet. / لم تتم إضافة أي مراجع بعد.</p>
              )}
              <button
                type="button"
                onClick={() => addDynamicField('references')}
                className="mt-2 text-blue-500"
              >
                Add Reference / إضافة مرجع
              </button>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}
